import { render, staticRenderFns } from "./FabricOrdering.vue?vue&type=template&id=444881ca&scoped=true"
import script from "./FabricOrdering.vue?vue&type=script&lang=js"
export * from "./FabricOrdering.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "444881ca",
  null
  
)

export default component.exports